module.exports = __webpack_public_path__ + "img/brand-9.eb642ac1.svg";